<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true ? 'Sale Report' : 'Deleted Sale Report'
                "
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/sale_reports/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="store_names"
                    solo
                    rounded
                    v-model="filter.store_name"
                    :items="storeNameItems"
                    clearable
                    @click:clear="(filter.store_name = null), (page = 1)"
                    label="Store"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    ref="sale_report"
                    solo
                    rounded
                    v-model="filter.store_location"
                    :items="storeLocationItems"
                    clearable
                    @click:clear="(filter.store_location = null), (page = 1)"
                    label="Store Location"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="2">
                  <v-autocomplete
                    ref="sale_report"
                    solo
                    rounded
                    v-model="filter.store_code"
                    :items="storeCodeItems"
                    clearable
                    @click:clear="(filter.store_code = null), (page = 1)"
                    label="Store Code"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <!-- Month Year -->
                <!-- <v-col sm="3">
                  <v-menu
                    v-model="month_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.month_year"
                        label="Year - Month"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="filter.month_year = null"
                        hide-details
                        :error-messages="errors.month"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.month_year"
                      type="month"
                      @input="
                        getData();
                        month_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col> -->
                <!-- /Month Year -->
                <!-- Start date -->
                <v-col sm="3">
                  <v-menu
                    v-model="start_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.start_date"
                        label="From"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="filter.start_date = null"
                        hide-details
                        :error-messages="errors.start_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.start_date"
                      @input="
                        getData();
                        start_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Start date -->
                <!-- End date -->
                <v-col sm="3">
                  <v-menu
                    v-model="end_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.end_date"
                        label="To"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="filter.end_date = null"
                        hide-details
                        :error-messages="errors.end_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.end_date"
                      @input="
                        getData();
                        end_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /End date -->
                <v-col>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        rounded
                        depressed
                        color="error"
                        class="my-auto"
                        @click="deleteAll(sale_reports.id)"
                        style="width: 90px; height: 50px"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Delete all Store</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="sale_reports.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                large
                class="primary"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="900"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Status</th>
                      <th>Store Name</th>
                      <th>Location</th>
                      <th>Store Code</th>
                      <th
                        v-for="(product, index) in products"
                        :key="index"
                        class="text-start"
                      >
                        {{ product.name }}
                        <v-btn icon small @click="sortBy(product.name)">
                          <v-icon>mdi-sort</v-icon>
                        </v-btn>
                      </th>
                      <th>Transporter</th>
                      <th>Driver</th>
                      <th>Vehicle</th>
                      <th>Total Amount</th>
                      <th class="text-right">Total Gifts</th>
                    </tr>
                  </thead>
                  <tbody v-if="sortedSaleReports.length">
                    <tr
                      v-for="(sale_report, i) in sortedSaleReports"
                      :key="`sale_report_${i}`"
                    >
                      <td>{{ i + 1 }}</td>
                      <td>
                        <v-chip
                          :color="sale_report.is_active ? 'teal' : 'red'"
                          text-color="white"
                        >
                          {{ sale_report.is_active ? "Active" : "Inactive" }}
                        </v-chip>
                      </td>
                      <td>{{ sale_report.business_name || "" }}</td>
                      <td>{{ sale_report.store_location || "" }}</td>
                      <td>{{ sale_report.store_code || "" }}</td>
                      <!-- Check if product name exists as a key in sale_report object -->
                      <!-- Check if the product name exists in sale_report object and display its value -->
                      <!-- Dynamically match and display product values -->
                      <td v-for="(product, index) in products" :key="index">
                        {{
                          Object.prototype.hasOwnProperty.call(
                            sale_report,
                            product.name
                          )
                            ? sale_report[product.name]
                            : 0
                        }}
                      </td>
                      <!-- Loop Through Products and Show Quantity -->
                      <!-- <td v-for="(product, index) in products" :key="index">
                        {{
                          sale_reports.
                          // sale_report.product_data.find(
                          //   (p) => p.name === product.name
                          // )?.p.name || 0
                        }}
                      </td> -->

                      <td>{{ sale_report.transporter_count || 0 }}</td>
                      <td>{{ sale_report.driver_count || 0 }}</td>
                      <td>{{ sale_report.vehicle_count || 0 }}</td>
                      <td>{{ sale_report.total_amount || "" }}</td>
                      <td>{{ sale_report.total_gifts || "" }}</td>
                      <!-- <td class="text-right">
                        <v-btn
                          class="mr-2"
                          fab
                          x-small
                          color="primary"
                          @click="Delete_this(sale_report.id)"
                        >
                          <v-icon dark> mdi-delete </v-icon>
                        </v-btn>
                      </td> -->
                    </tr>
                  </tbody>

                  <tbody v-else>
                    <tr>
                      <td colspan="10" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_sale_report" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Store deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_sale_report = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Resale_report Success Dialog Box -->
      <v-dialog v-model="is_resale_reportd_sale_report" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-resale_report
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Store resale_reportd successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_resale_reportd_sale_report = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "StoresPage",
  data() {
    return {
      form: {},
      filter: {
        search_keyword: "",
        store_location: "",
        store_code: "",
        store_name: "",
        is_active: "",
        is_selected: false,
        month_year: "",
        start_date: "",
        end_date: "",
      },
      sale_reportItems: [],
      storeNameItems: [],
      storeLocationItems: [],
      storeCodeItems: [],
      sale_reports: [],
      products: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportRawMaterialTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      sortOrder: {},
      currentSort: null,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      is_resale_reportd_sale_report: false,
      isExcelloading: false,
      delete_sale_report: false,
      is_deleted_sale_report: false,
      is_select_all: false,
      isDeleteAll: false,
      month_menu: false,
      start_menu: false,
      end_menu: false,
    };
  },
  computed: {
    sortedSaleReports() {
      if (!this.currentSort) return this.sale_reports;

      return [...this.sale_reports].sort((a, b) => {
        const key = this.currentSort;

        if (
          !Object.prototype.hasOwnProperty.call(a, key) ||
          !Object.prototype.hasOwnProperty.call(b, key)
        ) {
          return 0;
        }

        return this.sortOrder === "asc" ? a[key] - b[key] : b[key] - a[key];
      });
    },
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getProductData();
    this.getData();
    this.getMasters();
  },
  methods: {
    sortBy(productName) {
      if (this.currentSort == productName) {
        this.sortOrder = this.sortOrder == "asc" ? "desc" : "asc";
      } else {
        this.currentSort = productName;
        this.sortOrder = "asc";
      }
    },
    async getMasters() {
      await axios
        .get(`sales/masters`)
        .then((masters) => {
          masters = masters.data;
          //State
          masters.stores.forEach((store) => {
            this.storeNameItems.push({
              id: store.id,
              text: store.business_name,
              value: store.business_name,
            });
            this.storeLocationItems.push({
              id: store.id,
              text: store.store_location,
              value: store.store_location,
            });
            this.storeCodeItems.push({
              id: store.id,
              text: store.store_code,
              value: store.store_code,
            });
          });
          console.log("storeName", this.storeNameItems);
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.store_name = this.filter.store_name
        ? this.filter.store_name
        : "";
      this.filter.store_code = this.filter.store_code
        ? this.filter.store_code
        : "";
      this.filter.store_location = this.filter.store_location
        ? this.filter.store_location
        : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&role_id=2" +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&position_id=" +
        this.filter.position_id +
        "&store_code=" +
        this.filter.store_code +
        "&store_name=" +
        this.filter.store_name +
        "&store_location=" +
        this.filter.store_location +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`reports?${query}`)
        .then((response) => {
          this.sale_reports = response.data.data;
          // Map sale_report products into key-value for easy lookup
          this.sale_reports.forEach((sale_report) => {
            sale_report.product_data = sale_report.products || [];
          });
          this.isLoading = false;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);

          //window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async getProductData() {
      this.isLoading = true;
      await axios
        .get(`/products`)
        .then((response) => {
          this.products = response.data.data; // Store products
          this.isLoading = false;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },

    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.store_name = this.filter.store_name
        ? this.filter.store_name
        : "";
      this.filter.store_code = this.filter.store_code
        ? this.filter.store_code
        : "";
      this.filter.store_location = this.filter.store_location
        ? this.filter.store_location
        : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      let response = [];
      let query =
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&position_id=" +
        this.filter.position_id +
        "&store_code=" +
        this.filter.store_code +
        "&store_name=" +
        this.filter.store_name +
        "&store_location=" +
        this.filter.store_location +
        "&start_date=" +
        this.filter.start_date +
        "&end_date=" +
        this.filter.end_date +
        "&month_year=" +
        this.filter.month_year +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/reports/exports?${query}`)
        .then((response) => window.open(`${response.data.file_url}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
    async Delete_this(id) {
      this.delete_sale_report = true;
      await axios
        .post(`/sale_reports/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_sale_report = false;
          this.is_deleted_sale_report = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);

          //window.location.href = "/auth/login";
        });
    },
    selectAll() {
      console.log(this.is_select_all);
      this.sale_reports.forEach((sale_report) => {
        sale_report.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      let deleteallIds = [];
      this.sale_reports.forEach((sale_report) => {
        if (sale_report.is_selected) deleteallIds.push(sale_report);
      });
      await axios
        .post("/sale_reports/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      // let response = await axios.post(/sync_users/update_date_all, this.form);
      this.isDeleteAll = false;
    },

    async Resale_report_this(id) {
      this.resale_report_sale_report = true;
      await axios
        .post(`/sale_reports/resale_report/${this.encryptIt(id)}`)
        .then(() => {
          this.resale_report_sale_report = false;
          this.is_resale_reportd_sale_report = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
